module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1249e514e1d239a4ef7d47542dc98122.png";